// extracted by mini-css-extract-plugin
export default {"root":"IconSelector_root__jDEA2","option":"IconSelector_option__99ItL","preview":"IconSelector_preview__ru3DF"};